export class PurchaseModel {

    id: string;
    viewKey?: number;
    odds?: string;
    stake?: string;
    return?: string;
    tax?: string;
    messages?: string[];
    oddsUpdated?: boolean;
    shouldAcceptNewOdds?: boolean;
    stakeUpdated?: boolean;

    constructor(source: PurchaseModel) {
        this.id = source.id;
        this.viewKey = source.viewKey;
        this.odds = source.odds;
        this.stake = source.stake;
        this.return = source.return;
        this.tax = source.tax;
        this.messages = source.messages;
        this.oddsUpdated = source.oddsUpdated;
        this.shouldAcceptNewOdds = source.shouldAcceptNewOdds;
        this.stakeUpdated = source.stakeUpdated;
    }
}